// extracted by mini-css-extract-plugin
export default {"button":"LanguageSelector_button__89knB","menu":"LanguageSelector_menu__gdg85","item":"LanguageSelector_item__k-jhk"};